import { ChangeDetectorRef, Component, DestroyRef, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MediaMatcher } from '@angular/cdk/layout';
import { MenuItems } from '../../../shared/menu-items/menu-items';
import { DemoMaterialModule } from 'src/app/demo-material-module';
import { CommonModule, NgFor, NgIf } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { BrandingService } from '../../../services/branding.service';
import { DEFAULT_BRAND_NAME } from '../../../models/branding.model';
@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [DemoMaterialModule, NgFor, NgIf, RouterModule, CommonModule, MatIconModule],
  templateUrl: './sidebar.component.html',
  styleUrls: [],
})
export class AppSidebarComponent implements OnDestroy {
  @Input() compact = false;
  @Input() showCompactToggle = true;
  @Output() compactChange = new EventEmitter<boolean>();
  @Output() navigationSelected = new EventEmitter<void>();

  /** Active brand name, resolved by the backend (public branding). */
  brandName = DEFAULT_BRAND_NAME;

  mobileQuery: MediaQueryList;

  private _mobileQueryListener: () => void;

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public menuItems: MenuItems,
    private readonly brandingService: BrandingService,
    private readonly destroyRef: DestroyRef,
  ) {
    this.mobileQuery = media.matchMedia('(min-width: 768px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.brandingService
      .getInfo()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(info => (this.brandName = info.name));
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  toggleCompact(): void {
    this.compactChange.emit(!this.compact);
  }
}
